<transport-detail-sidebar-references [details]="details()" />

@if (renderQuickselect()) {
  <div class="detail-sidebar__separator w-100 my-4"></div>
  <transport-detail-sidebar-quickselect [details]="details()" />
}
